import React, { useState } from "react";
import { get } from "lodash";
import { useCurrentUser } from "store/users/selectors";
import StudentHome from "containers/StudentHome";
import TeacherHome1 from "containers/TeacherHome1";

const TopDrawers = ({
  children,
  onOpenDrawer = () => {},
  setOpenMenuClass,
  openMenuClass,
}) => {
  const currentUser = useCurrentUser();
  const is_Student = get(currentUser, "role") === "student";
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <div>
        {is_Student ? (
          <StudentHome fromDrawer={true} onCloseMenuBook={() => {
            setOpenMenuClass(false);
          }}
          openMenuClass={openMenuClass}
          from_menu={true}
          />
        ) : (
          <TeacherHome1
            onCloseMenuBook={() => {
              setOpenMenuClass(false);
            }}
            openMenuClass={openMenuClass}
            fromDrawer={true}
            setVisible={setVisible}
            from_menu={true}
          />
        )}
      </div>
      <div
        onClick={() => {
          onOpenDrawer();
        }}
        style={{ cursor: "pointer", padding: "10px" }}
      >
        {children}
      </div>
    </div>
  );
};

export default TopDrawers;
